<div class="d-flex flex-wrap justify-content-between align-items-start mb-6">
  <label class="col-12 col-lg-4 col-form-label" [class.required]="required">{{ label }}</label>
  <div class="col-12 col-lg-8">
    <div class="my-2" *ngIf="hasMitraList()">
      <ng-template [ngTemplateOutlet]="viewMitraList"></ng-template>
    </div>

    <div class="mb-2" *ngIf="chipsListData && chipsListData.length">
      <app-chips-legacy [chipsList]="chipsListData" (dataOutput)="handleOutputChips($event)"></app-chips-legacy>
    </div>

    <button class="btn btn-outline" type="button" mat-button color="primary" (click)="handleOpenDialog()" [disabled]="loading.value">
      <span class="svg-icon svg-icon-2" [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS"></span>
      <span class="text-primary pe-2">
        <ng-container *ngIf="loading.value; else defaultCtaLabel">
          <span>fetching data...</span>
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </ng-container>
        <ng-template #defaultCtaLabel>
          {{ labelOpenModalForm }}
        </ng-template>
      </span>
    </button>
  </div>
</div>

<app-modal-form #modalForm [modalConfig]="modalFormConfig">
  <!-- SELECTED CHIPS -->
  <div *ngIf="listSelectedItems.length" class="mb-4">
    <app-chips-legacy [chipsList]="listSelectedItems" (dataOutput)="handleOutputChips($event)"></app-chips-legacy>
  </div>

  <!--  SEARCH BOX -->
  <div class="multiselect-search mb-4" [class.mb-6]="loading.value">
    <div class="input-group">
      <input class="form-control" type="text" placeholder="Silahkan cari Kelurahan" [(ngModel)]="searchKeyword" (ngModelChange)="handleChangeKeyword($event)" />
      <span class="input-group-text">
        <span class="svg-icon svg-icon-2" [inlineSVG]="STRING_CONSTANTS.ICON.IC_SEARCH"></span>
      </span>
    </div>

    <ng-container *ngIf="isNoSearchResults()">
      <ng-template [ngTemplateOutlet]="notFound"></ng-template>
    </ng-container>

    <ng-template [ngTemplateOutlet]="failedFetchMitraList" *ngIf="fetchMitraHasError | async"></ng-template>
  </div>

  <!--  CHECKBOX LIST -->
  <ng-template #listItemsTpl>
    <div class="multiselect-list mh-200px overflow-scroll mb-4" #selectListContainer>
      <ng-container *ngFor="let item of listItemsBank | filter : searchKeyword : filterMeta; index as index; let last = last">
        <div
          appObserveIntersection
          #intersection="intersection"
          class="form-check my-6 text-capitalize"
          [debounceTime]="300"
          [root]="selectListContainer"
          [class.is-intersecting]="intersection._isIntersecting && last"
          (isIntersecting)="last ? isIntersecting($event) : null"
        >
          <input (change)="handleChangeSelection()" [(ngModel)]="item.selected" class="form-check-input cursor-pointer" id="flexCheckDefault-{{ item.id }}" type="checkbox" />
          <label class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize" for="flexCheckDefault-{{ item.id }}">
            {{ item.name | lowercase }}
          </label>
        </div>
      </ng-container>

      <ng-container *ngIf="loading | async">
        <ng-template [ngTemplateOutlet]="listLoader"></ng-template>
      </ng-container>
    </div>
  </ng-template>

  <ng-container *ngIf="!listItemsBank.length && (loading | async); else listItemsTpl">
    <ng-template [ngTemplateOutlet]="listLoader"></ng-template>
  </ng-container>

  <!--  CTA: ADD ITEMS -->
  <div class="d-flex justify-content-end">
    <button (click)="handleAddChips()" class="btn btn-primary" type="button" [disabled]="!listSelectedItems.length || loading.value">
      <div class="d-flex align-items-center">
        <span>{{ ctaLabelAdd }}</span>
        <span *ngIf="loading.value" class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </div>
    </button>
  </div>
</app-modal-form>

<ng-template #listLoader>
  <app-input-listbox-loader></app-input-listbox-loader>
</ng-template>

<ng-template #notFound>
  <div class="d-flex justify-content-center align-items-center flex-column py-10">
    <span class="svg-icon svg-icon-empty mb-10" [inlineSVG]="STRING_CONSTANTS.ICON.IC_LOCATION_NONE"></span>
    <p class="fs-5 mb-0">Data kelurahan tidak ditemukan.</p>
  </div>
</ng-template>

<ng-template #viewMitraList>
  <app-note-view [color]="'warning'" [extraContent]="true" [icon]="STRING_CONSTANTS.ICON.IC_DANGER_EXPIRED">
    <div style="color: #85774f">
      <p class="mb-2">Terdapat kelurahan yang sudah menjadi cakupan Retailer/Mitra Maxxi Tani:</p>
      <ul class="ps-6">
        <li *ngFor="let mitra of macMitraList$ | async">
          <span>{{ mitra.name }}</span>
          <span class="ms-2"> - {{ renderMitraList(mitra.retailer) }}</span>
        </li>
      </ul>
    </div>
  </app-note-view>
</ng-template>

<ng-template #failedFetchMitraList>
  <div class="mt-8">
    <app-note-view [color]="'danger'" [text]="fetchMitraResp.value" [icon]="STRING_CONSTANTS.ICON.IC_DANGER"> </app-note-view>
  </div>
</ng-template>
